import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import {
  formatSemestreLabel,
  getTrayectoById,
  sortMaterias,
} from "../../utils/curriculumMalla";
import { formatMallaCourseStats } from "../../utils/mallaCourseDisplay";

function MallaMobileList({
  materias,
  meta,
  mallaTitulo,
  onSelectMateria,
  axisLabel = "Trayecto",
}) {
  const sorted = sortMaterias(materias, meta);

  return (
    <section
      className="course-detail__malla course-detail__malla--mobile"
      aria-labelledby="malla-mobile-heading"
    >
      <Container fluid>
        <div className="course-detail__malla__header">
          <div className="spacer--red" />
          <h3 id="malla-mobile-heading">{mallaTitulo}</h3>
        </div>

        <Accordion
          className="course-detail__mobile-accordion"
          defaultActiveKey={meta.fases?.[0]?.id}
        >
          {(meta.fases ?? []).map((fase) => (
            <Accordion.Item eventKey={fase.id} key={fase.id}>
              <Accordion.Header>{fase.label}</Accordion.Header>
              <Accordion.Body>
                {fase.semestres.map((sem) => {
                  const semMaterias = sorted.filter((m) => m.Semestre === sem);
                  if (semMaterias.length === 0) return null;

                  return (
                    <div key={sem} className="course-detail__mobile-semestre">
                      <h4>{formatSemestreLabel(sem)}</h4>
                      <ul className="course-detail__mobile-materias">
                        {semMaterias.map((m) => {
                          const trayecto = getTrayectoById(meta, m.Trayecto);
                          return (
                            <li
                              key={m.id}
                              style={{
                                backgroundColor: trayecto?.color || "#fff",
                                color: trayecto?.textColor || "#5C2A2A",
                              }}
                              className={
                                onSelectMateria
                                  ? "course-detail__mobile-materias__item--interactive"
                                  : undefined
                              }
                              tabIndex={onSelectMateria ? 0 : undefined}
                              role={onSelectMateria ? "button" : undefined}
                              onClick={
                                onSelectMateria
                                  ? () => onSelectMateria(m, trayecto)
                                  : undefined
                              }
                              onKeyDown={
                                onSelectMateria
                                  ? (e) => {
                                      if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        onSelectMateria(m, trayecto);
                                      }
                                    }
                                  : undefined
                              }
                            >
                              <span className="course-detail__mobile-materias__trayecto">
                                {trayecto?.label}
                              </span>
                              {m.Clave && (
                                <span className="course-detail__materia-item__clave">
                                  {m.Clave}
                                </span>
                              )}
                              <strong title={m.Titulo}>{m.Titulo}</strong>
                              <span>{formatMallaCourseStats(m)}</span>
                              {onSelectMateria && (
                                <span
                                  className="course-detail__mobile-materias__tap-hint"
                                  aria-hidden="true"
                                >
                                  Ver detalle ›
                                </span>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}

export default MallaMobileList;
